
/* styles */
require("!!vue-loader/node_modules/vue-style-loader!css-loader?minimize!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-36b23fe6\",\"scoped\":true,\"hasInlineConfig\":false}!less-loader!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./contract_2_1.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./contract_2_1.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-36b23fe6\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./contract_2_1.vue"),
  /* scopeId */
  "data-v-36b23fe6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modules/supplier/contract/edit/contract_2_1.vue
// module id = 115
// module chunks = 0